// extracted by mini-css-extract-plugin
export default {"card":"Z2-z"};